/* NB Auto Voucher – single global logic
   - No MutationObserver
   - Scoped updates within root
   - One global change listener
   - Supports: dispatch:nb-auto-voucher:init (AJAX injected blocks)

   IMPORTANT:
   - Wrap selector MUST match the Liquid markup attribute.
   - We use [data-nb-voucher] because your snippet has: data-nb-voucher
*/

(function () {
  if (window.NBAutoVoucher) return;
  var selectedVariants = new WeakMap();

  function toNum(v) {
    var n = Number(v);
    return Number.isFinite(n) ? n : 0;
  }

  function formatBGNFromCents(cents) {
    var v = toNum(cents) / 100;
    try {
      return new Intl.NumberFormat('bg-BG', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(v);
    } catch (e) {
      return v.toFixed(2).replace('.', ',');
    }
  }

  function updateEUR(element, cents, wrap) {
    if (!element) return;
    var superscript = !!element.querySelector('sup');
    var formatter = new Intl.NumberFormat(wrap.getAttribute('data-nb-locale') || 'bg-BG', {
      style: 'currency', currency: 'EUR',
      currencyDisplay: wrap.getAttribute('data-nb-currency-display') === 'code' ? 'code' : 'symbol',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    var fragment = document.createDocumentFragment();
    formatter.formatToParts(cents / 100).forEach(function (part) {
      if (superscript && part.type === 'decimal') return;
      if (superscript && part.type === 'fraction') {
        var sup = document.createElement('sup'); sup.textContent = part.value; fragment.appendChild(sup);
      } else fragment.appendChild(document.createTextNode(part.value));
    });
    element.replaceChildren(fragment);
  }

  function closestScope(el) {
    return (
      el.closest('.drawer, .modal, .quickbuy, .quick-add, .quick-add-drawer, .quick-add__drawer') ||
      el.closest('product-card') ||
      el.closest('.card') ||
      el.closest('.product, .product-main, .main-product') ||
      document
    );
  }

  function findHostForWrap(wrap) {
    if (!wrap) return null;

    var direct =
      wrap.closest('product-card') ||
      wrap.closest('.card') ||
      wrap.closest('.product, .product-main, .main-product');

    if (direct && direct.querySelector && direct.querySelector('.price')) return direct;

    var node = wrap.parentElement;
    var hops = 0;
    while (node && node !== document.body && hops < 12) {
      if (node.querySelector && node.querySelector('.price')) return node;
      node = node.parentElement;
      hops += 1;
    }

    var scope = closestScope(wrap);
    if (scope && scope.querySelector && scope.querySelector('.price')) return scope;

    return wrap;
  }

  function toggleHasVoucherClass(wrap, isOn) {
    var host = findHostForWrap(wrap);
    if (!host || !host.classList) return;
    host.classList.toggle('nb-has-auto-voucher', !!isOn);
  }

  function getActiveVariantData(scope) {
    if (!scope || scope === document || !scope.querySelector) return { price: null, compareAt: null };

    var checked = scope.querySelector('input.js-option:checked[data-variant-id]');
    if (checked) {
      return {
        price: toNum(checked.getAttribute('data-variant-price')),
        compareAt: toNum(checked.getAttribute('data-variant-compare-at'))
      };
    }

    return { price: null, compareAt: null };
  }

  function updateWrap(wrap) {
    if (!wrap) return;

    var autoPct = toNum(wrap.getAttribute('data-auto-pct'));
    var fx = toNum(wrap.getAttribute('data-fx')) || 1.95583;

    if (autoPct <= 0) {
      wrap.style.display = 'none';
      toggleHasVoucherClass(wrap, false);
      return;
    }

    var scope = closestScope(wrap);
    var vd = selectedVariants.get(wrap) || getActiveVariantData(scope);

    // Ако няма данни за вариант (някои блокове), оставяме каквото е дошло от Liquid
    if (vd.price == null || vd.compareAt == null) {
      var initiallyVisible = wrap.getAttribute('data-nb-initial-visible') !== 'false';
      wrap.style.display = initiallyVisible ? '' : 'none';
      toggleHasVoucherClass(wrap, initiallyVisible);
      return;
    }

    var onSale = (vd.compareAt > vd.price && vd.price > 0);
    if (onSale || vd.price <= 0) {
      wrap.style.display = 'none';
      toggleHasVoucherClass(wrap, false);
      return;
    }

    /* ================================
       ✅ FIX 0.01: MATCH LIQUID EXACTLY
       Liquid does:
         discount_cents = floor(price_cents * pct / 100)
         voucher_cents  = price_cents - discount_cents
       ================================ */
    var discountCents = Math.floor((vd.price * autoPct) / 100);
    var voucherEur = vd.price - discountCents;

    // BGN display (approx) – round at the end
    var voucherBgn = Math.round(voucherEur * fx);
    updateEUR(wrap.querySelector('[data-nb-voucher-eur]'), voucherEur, wrap);

    var bgnEl = wrap.querySelector('[data-nb-voucher-bgn]');
    if (bgnEl) {
      bgnEl.textContent = formatBGNFromCents(voucherBgn) + ' лв';
    }

    wrap.style.display = '';
    toggleHasVoucherClass(wrap, true);
  }

  function initWithin(root) {
    var r = root || document;
    if (!r.querySelectorAll) return;
    if (r.matches && r.matches('[data-nb-voucher]')) updateWrap(r);

    var wraps = r.querySelectorAll('[data-nb-voucher]');
    for (var i = 0; i < wraps.length; i++) {
      updateWrap(wraps[i]);
    }
  }

  window.NBAutoVoucher = {
    initWithin: initWithin,
    updateWrap: updateWrap
  };

  window.NBAutoVoucherInit = function (root) {
    initWithin(root || document);
  };

  if (!window.__NB_AUTO_VOUCHER_GLOBAL_LISTENER__) {
    window.__NB_AUTO_VOUCHER_GLOBAL_LISTENER__ = true;

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !(t.matches && t.matches('input.js-option'))) return;

      var scope =
        t.closest('.drawer, .modal, .quickbuy, .quick-add, .quick-add-drawer, .quick-add__drawer, product-card, .card, .product, .product-main, .main-product') ||
        document;

      initWithin(scope);
    });

    document.addEventListener('dispatch:nb-auto-voucher:init', function (e) {
      var root = (e && e.detail && e.detail.root) ? e.detail.root : document;
      initWithin(root);
    });

    document.addEventListener('on:variant:change', function (e) {
      var picker = e.target;
      var product = e.detail && e.detail.product;
      if (!picker || !picker.closest || !product || !product.id) return;
      var root = picker.closest('quick-add-drawer, .drawer, .modal') ||
        picker.closest('.product-main, .main-product') || picker.closest('.js-product');
      if (!root) return;
      var variant = e.detail.variant;
      var vd = { price: variant ? toNum(variant.price) : 0,
        compareAt: variant ? toNum(variant.compare_at_price) : 0 };
      var wraps = root.querySelectorAll('[data-nb-voucher]');
      var matchedWrap = null;
      for (var i = 0; i < wraps.length; i++) {
        if (String(wraps[i].getAttribute('data-product-id')) !== String(product.id)) continue;
        matchedWrap = wraps[i];
        selectedVariants.set(wraps[i], vd);
        updateWrap(wraps[i]);
      }
      var priceRoot = picker.closest('.js-product');
      var base = priceRoot && priceRoot.querySelector('.product-info__price > .price');
      if (!base) return;
      var currentBgn = base.querySelector('.price__current-bgn');
      var wasBgn = base.querySelector('.price__was-bgn');
      var onSale = vd.compareAt > vd.price && vd.price > 0;
      var currentEur = base.querySelector('.price__current');
      var wasEur = base.querySelector('.price__was');
      if (onSale && !wasEur && currentEur) {
        wasEur = document.createElement('s');
        wasEur.className = 'price__was';
        currentEur.insertAdjacentElement('afterend', wasEur);
      }
      if (wasEur) {
        wasEur.hidden = !onSale;
        if (onSale) updateEUR(wasEur, vd.compareAt, matchedWrap || picker);
      }
      if (currentEur && currentEur.style) currentEur.style.color = onSale ? '#C72C41' : '';
      if (onSale && !wasBgn && currentBgn) {
        wasBgn = document.createElement('s');
        wasBgn.className = 'price__was-bgn';
        currentBgn.insertAdjacentElement('afterend', wasBgn);
      }
      if (currentBgn) {
        currentBgn.textContent = '(' + formatBGNFromCents(Math.round(vd.price * 1.95583)) + ' лв)';
        currentBgn.hidden = !variant;
      }
      if (wasBgn) {
        wasBgn.textContent = onSale ? '(' + formatBGNFromCents(Math.round(vd.compareAt * 1.95583)) + ' лв)' : '';
        wasBgn.hidden = !onSale;
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  }
})();
